import React, { PureComponent } from "react";
import { scaleLinear } from "d3-scale";
import * as array from "d3-array";

export interface XAxisProps {
  children?: React.ReactNode;
  width: number;
  scale: any;
  numberOfTicks?: number;
  contentInset?: any;
  data: any;
  spacingInner?: number;
  spacingOuter?: number;
  formatLabel?: any;
  xAccessor?: any;
  svg?: any;
  min?: any;
  max?: any;
  style?: any;
}

export interface XAxisState {
  width: number;
  height: number;
}

class XAxis extends PureComponent<XAxisProps, XAxisState> {
  static defaultProps = {
    spacingInner: 0.05,
    spacingOuter: 0.05,
    contentInset: {},
    svg: {},
    xAccessor: ({ index }: { index: number }) => index,
    scale: scaleLinear,
    formatLabel: (value: any) => value,
  };

  constructor(props: XAxisProps) {
    super(props);
    this.state = {
      width: props.width,
      height: 45,
    };
  }

  _getX(domain: any) {
    const {
      scale,
      numberOfTicks,
      contentInset: { left = 0, right = 0 },
    } = this.props;

    const { width } = this.props;
    const x = scale()
      .domain(domain)
      .range([left, width - right])
      .nice(numberOfTicks);

    return x;
  }

  render() {
    const { width, style, data, xAccessor, formatLabel, numberOfTicks, svg, children, min, max } = this.props;

    const { height } = this.state;

    if (data.length === 0) {
      return <div style={style} />;
    }

    const values = data.map((item: any, index: number) => xAccessor({ item, index }));
    const extent = array.extent(values);
    const domain = [min || extent[0], max || extent[1]];
    const x = this._getX(domain);
    const ticks = x.ticks(numberOfTicks);
    return (
      <div style={style}>
        <div style={{ height: "45px", marginBottom: "20px" }}>
          {height > 0 && width > 0 && (
            <svg
              style={{
                //position: "absolute",
                top: 0,
                left: 0,
                width,
                height,
              }}
            >
              {children}
              {
                // don't render labels if width isn't measured yet,
                // causes rendering issues
                width > 0 &&
                  ticks.map((value: any, index: number) => {
                    const { svg: valueSvg = {} } = data[index] || {};
                    return (
                      <text
                        textAnchor="middle"
                        originx={x(value)}
                        alignmentBaseline="hanging"
                        {...svg}
                        {...valueSvg}
                        key={index}
                        x={x(value) + 13}
                        y={15}
                        transform={`rotate(45, ${x(value)}, 0)`}
                      >
                        {formatLabel(value, index, ticks.length - 1)}
                      </text>
                    );
                  })
              }
            </svg>
          )}
        </div>
      </div>
    );
  }
}

export default XAxis;
